import axios from "@/libs/axios";
import {handleCatch} from "@/utils";
export default {
    async getProvinceOfOrganization() {
        try {
            const response = await axios.get(`uni/reports/provinceOfOrganization`)
            const {data} = response
            return data.data
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
}
